import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './styles/index.scss';
import * as serviceWorker from './serviceWorker';
import AppRouter from "./core/AppRouter";
import appHistory from "./core/appHistory";
import api from "./core/api";
import './styles-v2/index.scss';


console.warn = () => {}
console.log("App started. React version : " + React.version + ".")
ReactDOM.render(
    <AppRouter/>,
    document.getElementById('root')
);

if (appHistory.search('one_time_login')) {
    let one_time_login = appHistory.search('one_time_login');
    api.get("cabinet/one_time_login?one_time_login=" + one_time_login).ok((msg) => {
        const token = msg.data.token;
        api.login(token);
        if (msg.data && msg.data.user.home_url && msg.data.user.home_url !== "/") {
            window.location.href = msg.data.user.home_url as string
        } else {
            window.location.href = process.env.PUBLIC_URL
        }
    }).error(() => {});
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
